import { useTranslation } from 'react-i18next';

import { ProductShape } from 'lib/util/productShape';

import styles from './ProductDetailsView.module.css';
import { ProductOutlineTabs, TabPane } from './ProductOutlineTabs/ProductOutlineTabs';
import { ScheduleTab } from './ScheduleTab/ScheduleTab';
import { PickupCheckinTab } from './PickupCheckinTab/PickupCheckinTab';
import { DropoffCheckoutTab } from './DropoffCheckoutTab/DropoffCheckoutTab';
import { ContentSection } from './ContentSection/ContentSection';

type Props = {
  product: ProductShape;
};

export const ProductOutlineView = ({ product }: Props) => {
  const { t } = useTranslation();

  const tabPanes: TabPane[] = [];
  if (product.schedule.length > 0) {
    tabPanes.push({
      header: t('Schedule'),
      content: () => <ScheduleTab product={product} />,
    });
  }

  if (product.pickupLocations.length > 0 || product.checkinLocations.length > 0) {
    tabPanes.push({
      header: t('Pickup / Checkin'),
      content: () => <PickupCheckinTab product={product} />,
    });
  }

  if (product.dropoffLocations.length > 0 || product.checkoutLocations.length > 0) {
    tabPanes.push({
      header: t('Dropoff / Checkout'),
      content: () => <DropoffCheckoutTab product={product} />,
    });
  }

  return (
    <ContentSection title={t('Outline')} englishTitle="Outline" className={styles['overview']}>
      <ProductOutlineTabs panes={tabPanes} />
    </ContentSection>
  );
};
